(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/account-selector/assets/javascripts/views/player-account.js') >= 0) return;  svs.modules.push('/components/syndicate/account-selector/assets/javascripts/views/player-account.js');

(function(Backbone, svs) {
  'use strict';

  svs.syndicate.account_selector.views.PlayerAccount = Marionette.View.extend({
    ui: {
      userAccountInput: '.user-account input'
    },

    triggers: {
      'change @ui.userAccountInput': 'account:click'
    },

    template: function(data) {
      return svs.syndicate.account_selector.templates.player_account(data);
    }
  });
})(Backbone, svs);


 })(window);